(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("scoreOnlineExamResource", ["$resource", scoreOnlineExamResource]);
    function scoreOnlineExamResource($resource) {
        return $resource("/api/scoreOnlineExams/:attemptId/:questionNumber/:action/", {}, {
            getScoreOnlineExamViewModel: {
                method: "GET",
                params: { action: "scoreOnlineExamViewModel" }
            },
            saveQuestionScore: {
                method: "POST",
                params: { action: "saveQuestionScore" }
            },
            saveQuestionComment: {
                method: "POST",
                params: { action: "saveQuestionComment" }
            },
            submitManualMarkedExam: {
                method: "POST",
                params: { action: "submitManualMarkedExam" }
            }
        });
    }
}());
